import React from "react";
import PropTypes from "prop-types";

export const SourceLabel = ({ result }) => {
  const rawFields = result.raw || {};
  const source = rawFields.commonsource || rawFields.source;
  if (!source) {
    return null;
  }
  const className = source.toLowerCase().replaceAll(" ", "-");

  return <span className={`source ${className}`}>{source}</span>;
};

SourceLabel.propTypes = {
  result: PropTypes.shape({
    raw: PropTypes.object
  })
};
